

const BASE_URL = 'https://fhanred-1.onrender.com';



export default BASE_URL;
